






































































































































































































































































































































































































































































































import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import UploadExcel from "../../../shared/components/UploadExcel/index.vue";
import {ExcelData} from "@/shared/components/UploadExcel/index.vue";
import {MAPPING_LADING_EXCEL} from "@/shared/constant";
import {FreightServiceStore} from "@/modules/freightservices/store";
import {FreightServiceParams} from "@/modules/freightservices/params";
import {FreightServiceAddStore} from "@/modules/freightserviceadds/store";
import {FreightServiceAddParams} from "@/modules/freightserviceadds/params";
import {FieldLadingExcel} from "@/enums/fieldladingexcel";
import {FreightService, FreightServiceAdd, Lading, Province} from "@/interfaces/entity";
import FreightServiceSelector from "@/shared/components/FreightServiceSelector/index.vue";
import FreightServiceAddSelector from "@/shared/components/FreightServiceAddSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {LadingPaymentCode, LadingPaymentType, LadingPickupType} from "@/enums/type";
import InputCurrency from "@/shared/components/InputCurrency/index.vue";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import {createLadingExcel, updateLadingExcel} from "@/modules/ladings/services";
import {cloneDeep} from 'lodash';
import {FormModel} from "ant-design-vue";
import {allRegions} from "@/modules/regions/services";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";
import ProvinceSelectorV2 from "@/modules/regionsv2/ProvinceSelectorV2/index.vue";
import DistrictSelectorV2 from "@/modules/regionsv2/DistrictSelectorV2/index.vue";
import WardSelectorV2 from "@/modules/regionsv2/WardSelectorV2/index.vue";
import EditableCell from "@/shared/components/EditableCell/index.vue";
import DistrictLabelV2 from "@/modules/regionsv2/DistrictLabelV2/index.vue";
import WardLabelV2 from "@/modules/regionsv2/WardLabelV2/index.vue";
import ProvinceLabelV2 from "@/modules/regionsv2/ProvinceLabelV2/index.vue";
import FreightServiceLabel from "@/modules/freightservices/List/components/Label.vue";
import FreightServiceAddLabel from "@/modules/freightserviceadds/List/components/Label.vue";
import union from 'lodash/union';
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import {getEnumKeyByEnumValue, getPublicPath, replacePrefixRegion, toSlug} from "@/shared/services/helper/utils";
import {DistrictStore} from "@/modules/regionsv2/district/store";
import {WardStore} from "@/modules/regionsv2/ward/store";
import {ProvinceStore} from "@/modules/regionsv2/province/store";
import PrintTable from "@/modules/ladings/FormExcel/components/Table.vue";
import PrintLading from "@/modules/ladings/Print/index.vue";
import {Options} from "@/plugins/print/lib/print";
import {LadingStore} from "@/modules/ladings/store";
import LadingPrintBill from "@/modules/ladings/Print/Bill/index.vue";
import DetailLadingPrint from "@/modules/ladings/Print/components/Detail.vue";

const columns = [
    // {
    //     title: 'STT',
    //     dataIndex: 'id',
    //     key: 'id',
    //     width: 80,
    //     fixed: 'left',
    // },
    {
        title: 'Mã vận đơn',
        dataIndex: 'ladingCode',
        key: 'ladingCode',
        width: 150,
        fixed: 'left',
        scopedSlots: {customRender: 'ladingCode'}
    },
    {
        title: 'Địa chỉ(*)',
        dataIndex: 'locationTo.address',
        key: 'locationToAddress',
        width: 450,
        fixed: 'left',
        scopedSlots: {customRender: 'locationToAddress'}
    },
    {
        title: 'Tỉnh/tp(*)',
        dataIndex: 'locationTo.provinceId',
        key: 'locationToProvince',
        width: 200,
        scopedSlots: {customRender: 'province'}
    },
    {
        title: 'Phường/xã',
        dataIndex: 'locationTo.districtId',
        key: 'locationToDistrict',
        width: 180,
        scopedSlots: {customRender: 'district'}
    },
    // {
    //     title: 'Phường/xã',
    //     dataIndex: 'locationTo.wardId',
    //     key: 'locationToWard',
    //     width: 220,
    //     scopedSlots: {customRender: 'ward'}
    // },
    {
        title: 'Mã đơn hàng',
        dataIndex: 'orderCode',
        key: 'orderCode',
        width: 150,
        scopedSlots: {customRender: 'orderCode'}
    },
    {
        title: 'Mã khách hàng(*)',
        dataIndex: 'customerCode',
        key: 'customerCode',
        width: 150,
        scopedSlots: {customRender: 'customerCode'}
    },
    {
        title: 'Đại diện gửi',
        dataIndex: 'locationFromName',
        key: 'locationFromName',
        width: 150,
        scopedSlots: {customRender: 'locationFromName'}
    },
    {
        title: 'SDT đại diện gửi',
        dataIndex: 'locationFromPhoneNumber',
        key: 'locationFromPhoneNumber',
        width: 150,
        scopedSlots: {customRender: 'locationFromPhoneNumber'}
    },
    {
        title: 'Số ĐT người nhận',
        dataIndex: 'locationTo.phoneNumber',
        key: 'locationToPhoneNumber',
        width: 150,
        ellipsis: true,
        scopedSlots: {customRender: 'locationToPhoneNumber'}
    },
    {
        title: 'Tên người nhận(*)',
        dataIndex: 'locationTo.name',
        key: 'locationToName',
        width: 300,
        ellipsis: true,
        scopedSlots: {customRender: 'locationToName'}
    },
    {
        title: 'ND Hàng hóa(*)',
        dataIndex: 'boxContent',
        key: 'boxContent',
        width: 150,
        scopedSlots: {customRender: 'boxContent'}
    },
    {
        title: 'Số kiện(*)',
        dataIndex: 'boxQuantity',
        key: 'boxQuantity',
        width: 100,
        scopedSlots: {customRender: 'boxQuantity'}
    },
    {
        title: 'Giá trị',
        dataIndex: 'boxPrice',
        key: 'boxPrice',
        width: 150,
        scopedSlots: {customRender: 'boxPrice'}
    },
    {
        title: 'TL(g)(*)',
        dataIndex: 'weightTemp',
        key: 'weightTemp',
        width: 100,
        scopedSlots: {customRender: 'weightTemp'}
    },
    {
        title: 'TLTC(g)(*)',
        dataIndex: 'weight',
        key: 'weight',
        width: 100,
        scopedSlots: {customRender: 'weight'}
    },
    {
        title: 'Thu hộ (COD)',
        dataIndex: 'codMoney',
        key: 'codMoney',
        width: 150,
        scopedSlots: {customRender: 'codMoney'}
    },
    {
        title: 'Dịch vụ(*)',
        dataIndex: 'freightServiceRowGuid',
        key: 'service',
        width: 250,
        scopedSlots: {customRender: 'service'}
    },
    {
        title: 'DV GTGT',
        dataIndex: 'freightServiceAddRowGuids',
        key: 'serviceAdd',
        width: 250,
        scopedSlots: {customRender: 'serviceAdd'}
    },
    {
        title: 'HTTT(*)',
        dataIndex: 'payment',
        key: 'payment',
        width: 120,
        scopedSlots: {customRender: 'payment'}
    },
    // {
    //     title: 'Ghi chú giao hàng',
    //     dataIndex: 'note',
    //     key: 'note',
    //     width: 200,
    //     scopedSlots: {customRender: 'note'}
    // },
    // {
    //     title: 'Lỗi',
    //     dataIndex: 'error',
    //     key: 'error',
    //     width: 200,
    //     fixed: 'right'
    // }
];
const form = {
    ladingDate: undefined,
    dataSource: []
};
@Component({
    name: "LadingFormExcel",
    components: {
        TooltipLabel,
        FreightServiceAddLabel,
        FreightServiceLabel,
        ProvinceLabelV2,
        WardLabelV2,
        DistrictLabelV2,
        EditableCell,
        WardSelectorV2,
        DistrictSelectorV2,
        ProvinceSelectorV2,
        AInputCustom,
        MillisecondDatePicker,
        CustomerSelector,
        InputCurrency,
        EnumSelector,
        FreightServiceAddSelector,
        FreightServiceSelector, UploadExcel,
        PrintLading, PrintTable, LadingPrintBill, DetailLadingPrint
    }
})
export default class extends mixins(CommonMixin) {
    @Prop({type: Boolean, default: false}) readonly isUpdateForm!: boolean;
    columns = cloneDeep(columns);
    dataSource: any = [];
    LadingPaymentType = LadingPaymentType;
    LadingPickupType = LadingPickupType;
    form = cloneDeep(form);
    isSubmitting = false;
    districtSlugs = [] as any[];
    wardSlugs = [] as any[];
    provinceIds = [] as any[];
    isHasData = false;
    // selectedRowLadings: any = [];
    returnDataSource: any = [];
    json_fields = {
        'WARD_ID': 'id',
        'WARD_NAME': 'name',
        'DISTRICT_ID': {
            field: 'district',
            callback: (value) => {
                return value.id;
            }
        },
        'DISTRICT_NAME': {
            field: 'district',
            callback: (value) => {
                return value.name;
            }
        },
        'PROVINCE_ID': {
            field: 'district',
            callback: (value) => {
                return value?.province?.id;
            }
        },
        'PROVINCE_NAME': {
            field: 'district',
            callback: (value) => {
                return value?.province?.name;
            }
        }
    };

    created() {
        FreightServiceStore.listFreightService({ params: {...new FreightServiceParams(), postOfficeRowGuid: this.currentPostOffice?.rowGuid, limit: 1000 }});
        FreightServiceAddStore.listFreightServiceAdd({ ...new FreightServiceAddParams(), postOfficeRowGuid: this.currentPostOffice?.rowGuid, limit: 1000 });
        ProvinceStore.listProvincesByCountryV21();
    }

    mounted() {
        if (!this.isUpdateForm) {
            this.columns.push({
                title: 'Ghi chú giao hàng',
                dataIndex: 'noteOther',
                key: 'noteOther',
                width: 200,
                scopedSlots: {customRender: 'noteOther'}
            })
        }
    }

    get freightServices() {
        return Object.values(FreightServiceStore.data);
    }

    get freightServiceAdds() {
        return Object.values(FreightServiceAddStore.data);
    }

    get provinces(): Province[] {
        return ProvinceStore.mapIdsByCountryId[1]?.map((id) => ProvinceStore.data[id]);
    }

    freightServiceAddIdToObject(ids: any[]) {
        return ids.map(id => FreightServiceAddStore.data[id]);
    }
    // async onChangeRecordCalculateFee(record) {
    //     if (
    //         record.locationTo.provinceId
    //         && record.locationTo.districtId
    //         && record.freightServiceRowGuid
    //         && record.weightTemp
    //         && record.payment
    //     ) {
    //         try {
    //             const results = await LadingStore.calculateMoney({
    //                 ...{},
    //                 receiverCountryId: record.locationTo.countryId || 1 ,
    //                 receiverProvinceId: record.locationTo.provinceId,
    //                 receiverDistrictId: record.locationTo.districtId,
    //                 receiverWardId: record.locationTo.wardId,
    //                 weight: record.weight || record.weightTemp,
    //                 freightServiceRowGuid: record.freightServiceRowGuid,
    //                 freightServiceAddRowGuids: record?.freightServiceAddRowGuids.join(","),
    //                 payment: record.payment,
    //                 codMoney: record.codMoney || 0,
    //                 feeExtra: record.feeExtra || 0,
    //             });
    //
    //             results.forEach((result: any) => {
    //                 switch (result.serviceCode) {
    //                     case "ALL":
    //                         record.totalFee = result.price;
    //                         break;
    //                     default:
    //                         break;
    //                 }
    //             });
    //         } catch (e) {
    //             // this.$message.error(e?.response?.data?.message || 'Tính phí thất bại');
    //         }
    //     }
    // }

    async onSuccessUpload(excelData: ExcelData) {
        if (!this.isValidFileExcel(excelData.header)) return;
        try {
            const result = await this.mapToJson(excelData.header, excelData.results);
            const resultValid = [] as any;
            const dataDistricts = await DistrictStore.getDistrictsForExcelV21({provinceIds: this.provinceIds, districtSlugs: this.districtSlugs});
            const dataWards = await WardStore.getWardsForExcelV21({districtIds: dataDistricts.map((d) => d.id) || [], wardSlugs: this.wardSlugs});
            const mapProvinceDistrict = {} as any;
            const mapDistrictWard = {} as any;
            dataDistricts.forEach((item) => {
                mapProvinceDistrict[item.provinceId + '_' + item.slug] = item;
            });
            dataWards.forEach((item) => {
                mapDistrictWard[item.districtId + '_' + item.slug] = item;
            });
            for (let i = 0; i < result.length; i++) {
                const item = result[i];
                const provinceId = item['locationTo']['provinceId'];
                const districtSlug = item['locationTo']['districtId'];
                if (districtSlug) {
                    const districtId = mapProvinceDistrict[provinceId + '_' + districtSlug]?.id;
                    // if (!districtId) {
                    //     this.$message.error(`Quận huyện không đúng. Vận đơn thứ ${ i + 1 }`);
                    //     return;
                    // }
                    item['locationTo']['districtId'] = districtId;
                    const wardSlug = item['locationTo']['wardId'];
                    if (wardSlug) {
                        const wardId = mapDistrictWard[districtId + '_' + wardSlug]?.id;
                        // if (!wardId) {
                        //     this.$message.error(`Phường xã không đúng. Vận đơn thứ ${ i + 1 }`);
                        //     return;
                        // }
                        item['locationTo']['wardId'] = wardId;
                    }
                }
                resultValid.push(item);
            }
            if (result.length != resultValid.length) return;
            this.form.dataSource = result;
        } catch (e) {
            console.log(e)
        }
    }

    isValidFileExcel(header) {
        const headers = Object.keys(MAPPING_LADING_EXCEL);

        if (!header || !Array.isArray(header) || ((header.length - 1) !== Object.keys(MAPPING_LADING_EXCEL).length)) {
            this.$message.error("File excel bị lỗi 1");
            return false;
        }
        for (let i = 1; i < header.length; i++) {

            if (!headers.includes(toSlug(header[i], '_').toLowerCase())) {
                this.$message.error("File excel bị lỗi 2 " + header[i]);
                return false;
            }
        }
        return true;
    }

    async mapToJson(header: Array<string>, results: Array<any>) {
        const headers = header.map(item => toSlug(item, '_').toLowerCase());
        const mapResults: any = [];
        let districtSlugs = [] as any[];
        let wardSlugs = [] as any[];
        let provinceIds = [] as any[];
        for (let i = 0; i < results?.length; i++) {
            const item = this.mapKeyRow(results[i]);
            const obj: any = {};
            obj['id'] = i + 1;
            obj['totalFee'] = 0;
            for (const key of headers) {
                const trueKey = MAPPING_LADING_EXCEL[key];
                if (trueKey) {
                    const trueKeys = trueKey.split('.');
                    if (trueKeys?.length === 2) {
                        if (!obj[trueKeys[0]])
                            obj[trueKeys[0]] = {} as any;
                        if (FieldLadingExcel.LocationToProvince === trueKey && isNaN(item[key])) {
                            let provinceId = this.provinces.find((province: Province) => province.code === item[key])?.id;
                            if (!provinceId)
                                provinceId = this.provinces.find((province: Province) => toSlug(replacePrefixRegion(province.name)) === toSlug(replacePrefixRegion(item[key])))?.id;
                            provinceIds = union(provinceIds, [provinceId]);
                            obj[trueKeys[0]][trueKeys[1]] = provinceId;
                        } else if(FieldLadingExcel.LocationToDistrict === trueKey) {
                            const districtSlg = toSlug(replacePrefixRegion(item[key]));
                            districtSlugs = union(districtSlugs, [districtSlg]);
                            obj[trueKeys[0]][trueKeys[1]] = districtSlg;
                        } else if(FieldLadingExcel.LocationToWard === trueKey) {
                            const wardSlg = toSlug(replacePrefixRegion(item[key]));
                            wardSlugs = union(wardSlugs, [wardSlg]);
                            obj[trueKeys[0]][trueKeys[1]] = wardSlg;
                        } else {
                            obj[trueKeys[0]][trueKeys[1]] = item[key];
                        }
                    } else {
                        obj[trueKeys[0]] = item[key];
                        if (trueKeys[0] === FieldLadingExcel.FreightService) {
                            obj[trueKeys[0]] = this.freightServices.find((service: FreightService) => service.serviceCode === item[key])?.rowGuid;
                        } else if (trueKeys[0] === FieldLadingExcel.FreightServiceAdds) {
                            obj[trueKeys[0]] = item[key]?.split(',').map((code: string) => {
                                return this.freightServiceAdds.find((serviceAdd: FreightServiceAdd) => serviceAdd.code === code)?.rowGuid || "";
                            }) || [];
                        } else if (trueKeys[0] === FieldLadingExcel.Payment) {
                            obj[trueKeys[0]] = LadingPaymentType[getEnumKeyByEnumValue(LadingPaymentCode, item[key])]
                        }
                    }
                }
            }
            const errors = this.validateBillLading(obj);
            if (errors.length)  {
                obj['error'] = errors.join(', ');
            }
            mapResults.push(obj);
        }
        this.provinceIds = provinceIds;
        this.districtSlugs = districtSlugs.filter((d) => d !== null && d !== undefined);
        this.wardSlugs = wardSlugs.filter((w) => w !== null && w !== undefined);
        return mapResults;
    }
    onUpdate() {
        if (!this.isValidForm()) return;
        (this.$refs.formLadingMultiple as FormModel).validate(async (valid) => {
            if (!valid) return;
            this.isSubmitting = true;
            this.form.dataSource = this.form.dataSource.map((item: any) => {
                return {
                    ...item,
                    locationTo: {
                        ...item.locationTo,
                        countryId: 1
                    }
                }
            }) as any;

            try {
                await updateLadingExcel({billLadings: this.form.dataSource});
                this.$message.success("Cập nhật danh sách vận đơn thành công");
                this.form = cloneDeep(form);
            } catch (e) {
                this.$message.error(e?.response?.data?.message || 'Tạo đơn thất bại');
            } finally {
                this.isSubmitting = false;
            }
        });
    }
    onSubmit() {
        if (!this.isValidForm()) return;
        (this.$refs.formLadingMultiple as FormModel).validate(async (valid) => {
            if (!valid) return;
            this.isSubmitting = true;
            this.form.dataSource = this.form.dataSource.map((item: any) => {
                return {
                    ...item,
                    ladingDate: this.form.ladingDate,
                    locationTo: {
                        ...item.locationTo,
                        countryId: 1
                    },
                    pickup: LadingPickupType.PostOffice
                }
            }) as any;
            try {
                this.returnDataSource = await createLadingExcel({billLadings: this.form.dataSource});
                this.$message.success("Tạo đơn thành công");
                this.form = cloneDeep(form);
                this.isHasData = true;
            } catch (e) {
                this.$message.error(e?.response?.data?.message || 'Tạo đơn thất bại');
            } finally {
                this.isSubmitting = false;
                this.returnDataSource = this.returnDataSource.data.datas
                this.returnDataSource.forEach((lading: Lading) => {
                  LadingStore.addLading(lading);
                })
            }
        });
    }

    get selectedRowGuids() {
      return LadingStore.selectedRowLadings;
    }

    isValidForm() {
        if (!this.form.ladingDate && !this.isUpdateForm) {
            this.$message.error("Chọn ngày gửi");
            return false;
        }

        if (!this.form.dataSource || !this.form.dataSource.length) {
            this.$message.error("Tải lên file excel để tạo vận đơn");
            return false;
        }

        if (this.form.dataSource.some(item => (item as any)?.error && (item as any)?.error?.length)) {
            this.$message.error("File có bản ghi không hợp lệ, Vui lòng kiểm tra lại.");
            return false;
        }
        return true;
    }

    validateBillLading(billLading) {

        const errors: Array<string> = [];
        
        if (!billLading.customerCode) {
            errors.push("Thiếu mã khách hàng");
        }
        if (!billLading.weight) {
            errors.push("Thiếu trọng lượng tính cước");
        }
        if (!billLading.weightTemp) {
            errors.push("Thiếu trọng lượng");
        }
        if (!billLading.locationTo.name) {
            errors.push("Thiếu tên người nhận");
        }
        if (!billLading.locationTo.address) {
            errors.push("Thiếu địa chỉ");
        }
        if (!billLading.locationTo.provinceId) {
            errors.push("Thiếu hoặc sai mã tỉnh");
        }
        if (!billLading.boxContent) {
            errors.push("Thiếu nội dung hàng hóa")
        }
        if (!billLading.boxQuantity) {
            errors.push("Thiếu số kiện");
        }
        if (!billLading.freightServiceRowGuid) {
            errors.push("Thiếu dịch vụ");
        }
        if (!billLading.payment) {
            errors.push("Thiếu hình thức thanh toán");
        }
        return errors;
    }

    async allRegions() {
        const {data} = await allRegions();
        return data.datas;
    }

    mapKeyRow(row) {
        const result = {};

        Object.keys(row).forEach(key => {
            result[toSlug(key, '_').toLowerCase()] = row[key];
        })

        return result;
    }
}
